import React from 'react';
import { useAuth } from '../../context/AuthContext';

const AdminRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { isAdmin } = useAuth();

  if (!isAdmin()) {
    return (
      <div className="container mx-auto px-4 py-8">
        <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded">
          <h2 className="text-xl font-bold mb-2">Admin Access Required</h2>
          <p>You don't have permission to access this page. Please contact your administrator.</p>
        </div>
      </div>
    );
  }

  return <>{children}</>;
};

export default AdminRoute;
